import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Spin } from 'antd';
import { z } from 'zod';
import { ErrorComponent } from '@/features/erro/components/ErrorComponent';
import {
    ApiVendaClonarParamsAcao,
    queryOptionsVendaClonar,
} from '@/features/venda/api/apiVendaClonar';
import { VendaEditPage } from '@/features/venda/page/edit/VendaEditPage';
import { VendaTipoSchema } from '@/features/venda/types/VendaTipo';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({
    idpk: StringToIdpkSchema,
    tipo: VendaTipoSchema,
});

const SearchSchema = z.object({
    formas_pagamento_gerar: z.enum(['S', 'N']),
    itens_atualizar: z.enum(['S', 'N']),
    ven_tabela_preco_idpk: z.number().nullable().optional(),
});

export const Route = createFileRoute('/a/venda/clonar/$tipo/$idpk')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    validateSearch: SearchSchema,
});

function Component() {
    const { idpk, tipo } = Route.useParams();
    const { ven_tabela_preco_idpk, ...search } = Route.useSearch();

    const { data, error, isPending } = useQuery(
        queryOptionsVendaClonar({
            body: { ven_tabela_preco_idpk: ven_tabela_preco_idpk ?? null },
            idpk,
            params: {
                acao: ApiVendaClonarParamsAcao.Clonar,
                novo_tipo: tipo,
                ...search,
            },
        }),
    );

    if (isPending) {
        return (
            <div className='flex min-h-[50vh] items-center justify-center'>
                <Spin size='large' />
            </div>
        );
    }

    if (error) {
        return <ErrorComponent error={error} />;
    }

    const vendaClonada = data.registros[0];
    if (!vendaClonada) {
        return <ErrorComponent error={new Error('A API não retornou os dados da nova venda.')} />;
    }

    return <VendaEditPage mode='clonar' tipo={tipo} vendaClonada={vendaClonada} />;
}
